module.exports = "/images/mail-send.svg";